import React from 'react';

const Bullet = ({ className, text }) => {
  return (
    <span className={`bullet${className ? ` ${className}` : ''}`}>{text}</span>
  );
};

export { Bullet };
